import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { attachScrollTriggerOrPlayNow } from "../utils/scrollTriggerHelpers";

gsap.registerPlugin(ScrollTrigger);

/**
 * Pre-Footer animation.
 *
 * Trigger: ScrollTrigger one-shot all'entrata in viewport (top 85%).
 *
 * Sequenza:
 *   T=0.0  Titolo (fade + slide-up + blur)
 *   T=0.3  Box in stagger 0.15s (fade + slide-up)
 *
 * Tutto con power2.out, in linea con il resto del sito.
 */

const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const initPrefooter = () => {
  const block = document.querySelector("[data-prefooter]");
  if (!block) return;

  const title = block.querySelector("[data-prefooter-title]");
  const boxes = block.querySelectorAll("[data-prefooter-box]");

  // Reduced motion: niente animazione
  if (prefersReducedMotion()) {
    block.setAttribute("data-prefooter-ready", "true");
    return;
  }

  // Stato iniziale GSAP
  if (title) gsap.set(title, { opacity: 0, y: 24, filter: "blur(8px)" });
  if (boxes.length) gsap.set(boxes, { opacity: 0, y: 24 });

  const tl = gsap.timeline({ paused: true });

  if (title) {
    tl.to(title, {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 1.2,
      ease: "power2.out",
    }, 0);
  }

  if (boxes.length) {
    tl.to(boxes, {
      opacity: 1,
      y: 0,
      duration: 1.0,
      ease: "power2.out",
      stagger: 0.15,
    }, 0.3);
  }

  // Attach ScrollTrigger o play immediato se già in viewport
  attachScrollTriggerOrPlayNow(tl, {
    trigger: block,
    onComplete: () => block.setAttribute("data-prefooter-ready", "true"),
  });
};

export default () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPrefooter);
  } else {
    initPrefooter();
  }
};